import logo from "../../../assets/img/logo-img.png";
import React from "react";

export const Logo = () => {
  return (
    <img src={logo} alt={"Logo"} width={"40px"} height={"auto"} />
  )
}